<template>
  <div>
    <div class="min-vh-100">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col xl="5" class="text-center text-sm-left">
          <h1 class="mr-sm-4 header-main text-uppercase">รายการสินค้า</h1>
        </b-col>
        <b-col xl="7" class="text-right d-flex justify-content-end">
          <b-input-group class="panel-input-serach">
            <b-form-input
              id="product-search"
              class="input-serach"
              v-model="filter.search"
              @keyup.enter="onSearchProduct()"
              placeholder="ค้นหาชื่อสินค้า, SKU, คอลเลคชั่นสินค้า"
            ></b-form-input>
            <b-input-group-prepend>
              <span class="icon-input m-auto pr-2" @change="onSearchProduct()">
                <font-awesome-icon icon="search" title="View" />
              </span>
            </b-input-group-prepend>
          </b-input-group>
          <b-dropdown
            id="dropdown-product"
            text="ตัวเลือกเพิ่มเติม"
            class="ml-2 dropdown-option"
          >
            <b-dropdown-item
              @click="
                $router.push({
                  path: `/product/details/0?brandID=${$route.query.brandID}`,
                })
              "
              >สร้างสินค้า Non-Sap</b-dropdown-item
            >
            <b-dropdown-item>นำออกข้อมูล</b-dropdown-item>
            <b-dropdown-item>ดาวน์โหลดไฟล์ต้นฉบับ</b-dropdown-item>
          </b-dropdown>
          <b-button v-b-toggle.sidebar-filter class="btn-filter ml-2">
            <font-awesome-icon
              icon="filter"
              title="filter-btn"
              class="main-color mr-0 mr-sm-1"
            />
            <span class="d-none d-sm-inline">ตัวกรอง </span>
          </b-button>
        </b-col>
      </CRow>
      <b-sidebar
        id="sidebar-filter"
        backdrop
        shadow
        backdrop-variant="dark"
        right
        ref="filterSidebar"
        aria-labelledby="sidebar-filter-title"
        no-header
      >
        <template #default="{ hide }">
          <div class="p-3 sidebar-filter-header d-flex justify-content-between">
            <h4 id="sidebar-filter-title" class="m-0">ตัวกรอง</h4>
            <font-awesome-icon
              class="my-auto"
              icon="times-circle"
              color="#FFFFFF"
              @click="hide"
            />
          </div>
          <div class="px-3 py-2">
            <div class="mt-2">
              <b-input-group class="panel-input-serach">
                <b-form-input
                  id="product-search"
                  class="input-serach"
                  placeholder="ค้นหาชื่อสินค้า, SKU, คอลลเลคชั่นสินค้า"
                  v-model="filter.search"
                ></b-form-input>
                <b-input-group-prepend>
                  <span class="icon-input m-auto pr-2">
                    <font-awesome-icon icon="search" title="View" />
                  </span>
                </b-input-group-prepend>
              </b-input-group>
            </div>
            <div class="mt-3">
              <div class="font-weight-bold mb-2">ประเภทสินค้าในระบบ</div>
              <b-row
                class="pl-3"
                v-for="productType in filterConfig.productTypeList"
                :key="productType.id"
              >
                <b-col>
                  <div class="form-check mb-2">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :value="productType.id"
                      v-model="productTypeSelected"
                      :id="'productType-' + productType.id"
                      @change="onProductTypeChange"
                    />
                    <label
                      class="form-check-label"
                      :for="'status-' + productType.id"
                      >{{ productType.name }}</label
                    >
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="mt-3">
              <div class="font-weight-bold mb-2">สถานะสินค้า</div>
              <b-row class="pl-3">
                <b-col>
                  <div class="form-check mb-2">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="productStatusAll"
                      :id="'status-All'"
                      @change="onProductStatusAllChange"
                    />
                    <label class="form-check-label" :for="'status-All'"
                      >ทั้งหมด</label
                    >
                  </div>
                </b-col>
              </b-row>
              <b-row
                class="pl-5"
                v-for="status in filterConfig.statusList"
                :key="status.id"
              >
                <b-col>
                  <div class="form-check mb-2">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :value="status.id"
                      v-model="filter.status"
                      :id="'status-' + status.id"
                      @change="onProductStatusChange"
                    />
                    <label
                      class="form-check-label"
                      :for="'status-' + status.id"
                      >{{ status.name }}</label
                    >
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="mt-3">
              <InputSelect
                title="หมวดหมู่ระดับที่ 1"
                name="categoryLevel1"
                :options="filterConfig.category.categoryLevel0"
                valueField="id"
                textField="name"
                v-model="categorySelected[0]"
                @onDataChange="onCategoryChange($event, 0)"
              />
            </div>
            <div class="mt-3">
              <InputSelect
                title="หมวดหมู่ระดับที่ 2"
                name="categoryLevel2"
                :options="filterConfig.category.categoryLevel1"
                valueField="id"
                textField="name"
                v-model="categorySelected[1]"
                @onDataChange="onCategoryChange($event, 1)"
              />
            </div>
            <div class="mt-3">
              <InputSelect
                title="หมวดหมู่ระดับที่ 3"
                name="categoryLevel3"
                :options="filterConfig.category.categoryLevel2"
                valueField="id"
                textField="name"
                v-model="categorySelected[2]"
                @onDataChange="onCategoryChange($event, 2)"
              />
            </div>
            <div class="mt-3">
              <InputSelect
                title="หมวดหมู่ระดับที่ 4"
                name="categoryLevel4"
                :options="filterConfig.category.categoryLevel3"
                valueField="id"
                textField="name"
                v-model="categorySelected[3]"
                @onDataChange="onCategoryChange($event, 3)"
              />
            </div>
            <div class="mt-3">
              <InputSelect
                title="คอลเลคชัน"
                name="collection"
                :options="filterConfig.collectionList"
                valueField="id"
                textField="name"
                v-model="filter.collectionName"
                @onDataChange="(val) => (filter.collectionName = val)"
              />
            </div>
            <div class="mt-3">
              <InputSelect
                title="จำนวนสินค้าในคลัง"
                name="stockStatus"
                :options="filterConfig.stockStatusList"
                valueField="stockStatusId"
                textField="stockStatusName"
                v-model="filter.stockStatusId"
                @onDataChange="(val) => (filter.stockStatusId = val)"
              />
            </div>
          </div>
        </template>

        <template #footer>
          <div
            class="
              d-flex
              justify-content-between
              shadow
              align-items-center
              border-top
            "
          >
            <div class="w-100">
              <b-button
                block
                size="lg"
                variant="light"
                class="text-dark w-100 border-radius-0 btn-clear-filter"
                @click="onClearFilter"
                >ล้างตัวกรอง</b-button
              >
            </div>
            <div class="w-100">
              <b-button
                block
                size="lg"
                variant="light"
                class="text-body btn-main w-100 border-radius-0"
                @click="onFilterProduct"
              >
                ยืนยัน
              </b-button>
            </div>
          </div>
        </template>
      </b-sidebar>
      <b-row class="no-gutters px-3 px-sm-0 mt-3">
        <b-col class="overflow-auto">
          <b-tabs class="mt-2 product-tabs mb-0">
            <b-tab
              v-for="(item, index) in statusList"
              :key="index"
              :title="item.name + ' (' + item.count + ')'"
              :active="isActive(item.id)"
              @click="onFilterProductByStatus(index)"
            >
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
      <div class="bg-white py-3 py-sm-0">
        <b-row class="no-gutters px-3 px-sm-0">
          <b-col>
            <b-table
              responsive
              class="text-center table-list mb-0"
              striped
              :fields="fields"
              :items="items"
              :busy="isBusy"
              show-empty
              empty-text="ไม่พบข้อมูล"
            >
              <template v-slot:cell(imageUrl)="data">
                <div class="position-relative">
                  <div
                    class="square-box b-contain"
                    v-bind:style="{
                      'background-image': 'url(' + data.item.imageUrl + ')',
                    }"
                  ></div>
                </div>
              </template>
              <template v-slot:cell(name)="data">
                <p class="mb-1 nobreak two-lines">{{ data.item.name }}</p>
                <b-badge
                  v-if="data.item.isSap"
                  pill
                  variant="danger"
                  class="px-3 py-2 sap mt-1"
                  >Sap</b-badge
                >
                <b-badge
                  v-else
                  pill
                  variant="danger"
                  class="px-3 py-2 non-sap mt-1"
                  >Non-Sap</b-badge
                >
              </template>
              <template v-slot:cell(stock)="data">
                <p class="m-0">{{ data.item.stock | numeral("0,0") }}</p>
                <b-badge
                  v-if="data.item.stock <= 0"
                  pill
                  variant="danger"
                  class="px-3 py-2 mt-1"
                  >หมด</b-badge
                >
                <b-badge
                  v-else-if="
                    data.item.stock <= data.item.stock.minimunStockAlert
                  "
                  pill
                  variant="warning"
                  class="text-white px-3 py-2 mt-1"
                  >เหลือน้อย</b-badge
                >
              </template>
              <template v-slot:cell(price)="data">
                <div>
                  <template v-if="data.item.advancePrice">
                    <p class="m-0">
                      ฿ {{ data.item.advancePrice | numeral("0,0.00") }}
                    </p>
                    <p class="m-0">
                      <del class="text-gray-1 f-size-14">
                        ฿ {{ data.item.price | numeral("0,0.00") }}</del
                      >
                    </p>
                  </template>
                  <template v-else>
                    <p class="m-0">
                      ฿ {{ data.item.price | numeral("0,0.00") }}
                    </p>
                  </template>
                </div>
              </template>

              <template v-slot:cell(salesChannels)="data">
                <div>
                  <b-img
                    v-for="(sale, index) in data.item.salesChannels"
                    :key="index"
                    fluid
                    :src="sale.imageUrl"
                    class="sale-img ml-2"
                    :alt="sale.name"
                  ></b-img>
                </div>
              </template>
              <template v-slot:cell(display)="data">
                <div v-if="data.item.display == true" class="">แสดง</div>
                <div v-else class="">ไม่แสดง</div>
              </template>
              <template v-slot:cell(enabled)="data">
                <div>
                  <b-form-checkbox
                    v-model="data.item.enabled"
                    class="switch-enabled"
                    name="check-button"
                    size="lg"
                    switch
                    @change="onChangeProductStatus(data.item)"
                  >
                  </b-form-checkbox>
                </div>
              </template>
              <template v-slot:cell(updatedTime)="data">
                <div>
                  {{
                    new Date(data.item.updatedTime) | moment($formatDateTime)
                  }}
                </div>
              </template>
              <template v-slot:cell(id)="data">
                <b-button variant="link" class="px-1 py-0">
                  <router-link
                    :to="
                      '/product/details/' +
                      data.item.id +
                      '?brandID=' +
                      $route.query.brandID
                    "
                    class="text-purple-1"
                  >
                    <u>แก้ไข</u>
                  </router-link>
                </b-button>
              </template>
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row class="no-gutters px-3 px-sm-0" v-if="!isBusy">
          <b-col
            class="form-inline justify-content-center justify-content-sm-end"
          >
            <div class="d-sm-flex m-3">
              <b-pagination
                v-model="filter.pageNo"
                :total-rows="rows"
                :per-page="filter.perPage"
                class="m-md-0 page-item"
                @change="pagination"
                align="center"
              ></b-pagination>
            </div>

            <b-form-select
              class="mr-sm-3 select-page"
              v-model="filter.perPage"
              @change="hanndleChangePerpage"
              :options="pageOptions"
            ></b-form-select>
          </b-col>
        </b-row>
      </div>
    </div>
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  components: {
    InputSelect,
    ModalAlertError,
    ModalLoading,
  },
  data() {
    return {
      fields: [
        {
          key: "imageUrl",
          label: `ภาพสินค้า`,
          class: "w-100px text-nowrap",
        },
        {
          key: "name",
          label: `ชื่อสินค้า`,
          class: "w-250px text-left",
        },
        { key: "sku", label: "Parent SKU", class: "w-100px text-left" },
        {
          key: "price",
          label: `ราคาป้าย`,
          class: "w-100px text-nowrap",
        },
        {
          key: "stock",
          label: `จำนวนคงเหลือ`,
          class: "w-100px text-nowrap",
        },
        {
          key: "marketingChanel",
          label: `ช่องทางจำหน่าย`,
          class: "w-100px text-nowrap",
        },
        {
          key: "updatedTime",
          label: `อัพเดทล่าสุด`,
          class: "w-100px text-nowrap",
        },
        {
          key: "display",
          label: `สถานะ`,
          class: "w-50px text-nowrap",
        },
        {
          key: "enabled",
          label: `สถานะการแสดงผล`,
          class: "w-100px text-nowrap",
        },
        { key: "id", label: "", stickyColumn: true, class: "w-50px text-nowrap" },
      ],
      items: [],
      statusList: [
        {
          id: 0,
          name: "ทั้งหมด",
          count: 0,
        },
        {
          id: 1,
          name: "ใช้งาน",
          count: 0,
        },
        {
          id: 2,
          name: "ไม่ใช้งาน",
          count: 0,
        },
        {
          id: 3,
          name: "สินค้าหมด",
          count: 0,
        },
        {
          id: 4,
          name: "สินค้าใกล้หมด",
          count: 0,
        },
      ],
      activeItem: "",
      isBusy: false,
      filterConfig: {
        collectionList: [{ id: null, name: "ทั้งหมด" }],
        stockStatusList: [],
        salesChannelList: [],
        statusList: [
          { id: 1, name: "เปิดใช้งาน" },
          { id: 0, name: "ปิดใช้งาน" },
        ],
        productTypeList: [
          { id: 0, name: "จากระบบ SAP" },
          { id: 1, name: "สร้างใหม่จากระบบ ( Non SAP )" },
        ],
        category: {
          categoryLevel0: [
            {
              id: 0,
              name: "ทั้งหมด",
            },
          ],
          categoryLevel1: [
            {
              id: 0,
              name: "ทั้งหมด",
            },
          ],
          categoryLevel2: [
            {
              id: 0,
              name: "ทั้งหมด",
            },
          ],
          categoryLevel3: [
            {
              id: 0,
              name: "ทั้งหมด",
            },
          ],
        },
      },
      filter: {
        search: "",
        status: [0, 1],
        pageNo: 1,
        perPage: 10,
        selectTab: 0,
        newArrivalHot: [],
        stockStatusId: 3,
        category: null, // 0 คือไม่เลือก
        flagSyncExternalSync: null, // null คือไม่เลือก
        collectionName: null, //null คือไม่เลือก
      },
      productTypeSelected: [0, 1],
      stockStatusId: [],
      collectionSelected: 0,
      categorySelected: [0, 0, 0, 0],
      productStatusAll: true,
      rows: 0,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      modalMessage: "",
    };
  },
  created: async function () {
    await this.getProductFilter();
    await this.getFilter();
    await this.getProductList();
  },
  methods: {
    getFilter() {
      if (this.$route.query.search) {
        this.filter.search = this.$route.query.search;
      }
      if (this.$route.query.status) {
        this.filter.status = this.$route.query.status
          .split(",")
          .map(Number) || [0, 1];
      }
      if (this.$route.query.newArrivalHot) {
        this.filter.newArrivalHot =
          this.$route.query.newArrivalHot.split(",").map(Number) || [];
      }
      if (this.$route.query.selectTab) {
        this.filter.selectTab = parseInt(this.$route.query.selectTab) || 1;
        this.activeItem = this.$route.query.selectTab;
      }
      if (this.$route.query.stockStatusId) {
        this.filter.stockStatusId =
          parseInt(this.$route.query.stockStatusId) || 3;
      }
      if (this.$route.query.pageNo) {
        this.filter.pageNo = parseInt(this.$route.query.pageNo) || 1;
      }
      if (this.$route.query.perPage) {
        this.filter.perPage = parseInt(this.$route.query.perPage) || 10;
      }
      if (this.$route.query.category) {
        this.filter.category = parseInt(this.$route.query.category) || null;
      }
      if (this.$route.query.flagSyncExternalSync) {
        this.filter.flagSyncExternalSync =
          parseInt(this.$route.query.flagSyncExternalSync) || null;
      }
      if (this.$route.query.collectionName) {
        this.filter.collectionName =
          parseInt(this.$route.query.collectionName) || null;
      }
    },
    setFilter() {
      this.$router
        .push({
          path: "/product",
          query: {
            brandID: this.$route.query.brandID,
            search: this.filter.search,
            status: this.filter.status.toString(),
            pageNo: this.filter.pageNo,
            perPage: this.filter.perPage,
            newArrivalHot: this.filter.newArrivalHot.toString(),
            stockStatusId: this.filter.stockStatusId,
            category: this.filter.category,
            flagSyncExternalSync: this.filter.flagSyncExternalSync,
            collectionName: this.filter.collectionName,
            selectTab: this.filter.selectTab,
          },
        })
        .catch((err) => {});
    },
    onProductStatusChange() {
      if (this.filter.status.length == 2) {
        this.productStatusAll = true;
      } else {
        this.productStatusAll = false;
      }
    },
    onProductStatusAllChange(value) {
      if (this.productStatusAll) {
        this.filter.status = [0, 1];
      } else {
        if (this.filter.status.length == 2) {
          this.filter.status = [];
        }
      }
    },
    onClearFilter: async function () {
      this.filter = {
        search: "",
        status: [0, 1],
        pageNo: 1,
        perPage: 10,
        selectTab: 1,
        newArrivalHot: [],
        stockStatusId: 3,
        category: null, // 0 คือไม่เลือก
        flagSyncExternalSync: null, // null คือไม่เลือก
        collectionName: null, //null คือไม่เลือก
      };
      await this.setFilter();
      this.$refs.filterSidebar.hide();
      this.getProductList();
    },
    onProductTypeChange(event) {
      if (this.productTypeSelected.length == 2) {
        this.filter.flagSyncExternalSync = null;
      } else if (this.productTypeSelected.length == 1) {
        this.filter.flagSyncExternalSync = this.productTypeSelected[0];
      } else {
        this.filter.flagSyncExternalSync = null;
      }
    },
    onFilterProduct() {
      this.filter.pageNo = 1;
      this.setFilter();
      this.getProductList();
      this.$refs.filterSidebar.hide();
    },
    onFilterProductByStatus(statusTab) {
      this.filter.selectTab = statusTab;
      this.filter.pageNo = 1;
      this.setFilter();
      this.getProductList();
    },
    onSearchProduct() {
      this.filter.pageNo = 1;
      this.getProductList();
    },
    pagination(page) {
      this.filter.pageNo = page;
      this.setFilter();
      this.getProductList();
    },
    isActive: function (menuItem) {
      return this.activeItem == menuItem;
    },
    onChangeProductStatus: async function (product) {
      product.enabled = !product.enabled;
      this.$refs.modalLoading.show();
      await this.axios
        .patch(
          `${this.$baseUrl}/product/${product.id}/ChangeStatus/${product.enabled}`
        )
        .then((data) => {
          this.$refs.modalLoading.hide();
          if (data.result !== 1) {
            this.getProductList();
            this.modalMessage = data.detail[0];
            this.$refs.modalAlertError.show();
          }
        });
    },
    getProductList: async function () {
      this.isBusy = true;
      let pageNo = parseInt(this.filter.pageNo);
      await this.axios
        .post(`${this.$baseUrl}/product/search`, this.filter)
        .then((data) => {
          this.rows = data.detail.countTotal;
          this.items = data.detail.dataList;
          this.statusList[0].count = data.detail.countTotal;
          this.statusList[1].count = data.detail.used;
          this.statusList[2].count = data.detail.unused;
          this.statusList[3].count = data.detail.empty;
          this.statusList[4].count = data.detail.almostEmpty;
          this.isBusy = false;
        });
      this.filter.pageNo = pageNo;
    },

    getProductFilter: async function () {
      await this.axios.get(`${this.$baseUrl}/product/config`).then((data) => {
        let collectionName = data.detail.collection.map((el, index) => {
          return { id: el, name: el };
        });
        this.filterConfig.collectionList =
          this.filterConfig.collectionList.concat(collectionName);
        this.collectionSelected = this.filterConfig.collectionList[0];
        this.filterConfig.stockStatusList = data.detail.stockStatus;
      });
      this.getCategoryList(0, 0);
    },
    onCategoryChange(value, index) {
      this.categorySelected[index] = value;
      this.categorySelected.forEach((element, cindex) => {
        if (cindex > index) {
          this.filterConfig.category[`categoryLevel${cindex}`] = [
            {
              id: 0,
              name: "ทั้งหมด",
            },
          ];
          this.categorySelected[cindex] = 0;
        }
      });
      this.filter.category = value;
      this.getCategoryList(value, index + 1);
    },
    getCategoryList: async function (id, index) {
      await this.axios
        .get(`${this.$baseUrl}/productinventory/category/${id}`)
        .then((data) => {
          if (data.detail) {
            data.detail.category.forEach((cat) => {
              this.filterConfig.category[`categoryLevel${index}`].push({
                id: cat.categoryId,
                name: cat.categoryName,
              });
            });
          }
        });
    },
    hanndleChangePerpage: async function (value) {
      this.filter.pageNo = 1;
      this.filter.perPage = value;
      await this.setFilter();
      this.getProductList();
    },
  },
};
</script>

<style lang="scss" scoped>
.outofstock {
  background-color: #dc3545;
}
.non-sap {
  background-color: #5b57a547;
  color: #4f5d73;
}
.sap {
  background-color: #b41bb4;
  color: white;
}
.sale-img {
  height: 40px;
  width: 40px;
}

::v-deep .tab-content {
  margin: 0 !important;
}

::v-deep table th.b-table-sticky-column:last-child,
::v-deep table td.b-table-sticky-column:last-child {
  right: 0px !important;
}
::v-deep table th.b-table-sticky-column:last-child{
  background-color: #d1d0e6 !important;
}
::v-deep table td.b-table-sticky-column:last-child {
  background-color: white !important;
}
</style>
